export default "__VITE_ASSET__ba999460__"